import { render, staticRenderFns } from "./twoDetailsDialog.vue?vue&type=template&id=22cd47b6&scoped=true&"
import script from "./twoDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./twoDetailsDialog.vue?vue&type=script&lang=js&"
import style0 from "./twoDetailsDialog.vue?vue&type=style&index=0&id=22cd47b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cd47b6",
  null
  
)

export default component.exports